//@ts-check
import { getInformeByID } from "../api/informs";
import { ReportItem } from "../models/studies/report";

/**
 * @param {string|number} id
 * @returns {Promise<import("../models/studies/report").ReportItem[]>}
 */
export async function getInform(id) {
  /**
   * @type {import("../api/informs").InformeApiResponse}
   */
  let response = await getInformeByID(id);
  if (response.existe) {
    return response.list.map((item) => new ReportItem(item));
  } else {
    return [];
  }
}

/**
 *
 * @param {import("../models/studies/report").ReportItem} report
 */
export async function viewReport(report) {
  let response = await viewReport(report.id);
}
